'use strict';

export { ReanimatedFlatList as FlatList } from "./component/FlatList.js";
export { AnimatedImage as Image } from "./component/Image.js";
export { AnimatedScrollView as ScrollView } from "./component/ScrollView.js";
export { AnimatedText as Text } from "./component/Text.js";
export { AnimatedView as View } from "./component/View.js";
export { createAnimatedComponent } from "./createAnimatedComponent/index.js";
export { addWhitelistedNativeProps, addWhitelistedUIProps } from "./deprecated.js";
//# sourceMappingURL=Animated.js.map